import React from "react";

export default function Checkbox({ id, text, checked, onChange, className }) {
  const handleChange = (e) => {
    onChange(e, id);
  };

  return (
    <label className={className}>
      <input
        type="checkbox"
        className="mr-2"
        checked={checked}
        onChange={handleChange}
      />
      <span dangerouslySetInnerHTML={{ __html: text }} />
    </label>
  );
}
